import React from "react";

import PersonalInfoForm from "../components/profile/PersonalInfoForm";
import { EditFarmerInfoScreenProps } from "../routes/types";

const AddFarmerInfo = ({ route }: EditFarmerInfoScreenProps) => {
  const { name, phoneNumber } = route.params;

  return (
    <PersonalInfoForm
      phoneNumber={phoneNumber}
      name={name}
      farmingArea={null}
      landAreaUnit={null}
    />
  );
};

export default AddFarmerInfo;
